/**
 * 符卡挑战历史（本地 localStorage）：东方符卡列表惯例的「取得数/挑战数」。
 * key 统一为 `${stageIndex(0基)}-${kind('mid'|'big')}-${spellIdx}`，练习/正常模式共享
 * （同一张符卡无论在哪个模式挑战都计入同一行）。Node 无 localStorage 时静默跳过。
 */

const KEY = 'kimi-spell-history';

/** 读全量历史（{key: {attempts, captured}}）。 */
export function readSpellHistory() {
  try {
    const h = JSON.parse(globalThis.localStorage?.getItem(KEY) || '{}');
    return h && typeof h === 'object' ? h : {}; // JSON 'null' 合法但非对象（历史 bug：每帧 TypeError）
  } catch (e) {
    return {};
  }
}

/**
 * 记录一次挑战结果。
 * @param {string} key spellKey() 产物
 * @param {boolean} captured 是否取得（无伤无雷无技能且限时内击破）
 */
export function recordSpellResult(key, captured) {
  try {
    const h = readSpellHistory();
    const rec = h[key] || { attempts: 0, captured: 0 };
    rec.attempts++;
    if (captured) rec.captured++;
    h[key] = rec;
    globalThis.localStorage?.setItem(KEY, JSON.stringify(h));
  } catch (e) { /* 忽略 */ }
}

/** 历史键：关卡(0基) + boss 类别 + 符卡在 boss 符卡序列中的序号。 */
export function spellKey(stageIndex, kind, spellIdx) {
  return `${stageIndex}-${kind}-${spellIdx}`;
}

/** boss 当前阶段在其符卡序列中的序号（非符阶段不计）。 */
export function spellIndexOf(boss) {
  let n = 0;
  for (let i = 0; i < boss.phaseIndex && i < boss.phases.length; i++) {
    if (boss.phases[i].spellCard) n++;
  }
  return n;
}
